import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_contracts_for_all_persons_who_perform_work_for_the_fac_both'

export const dataPointDefinition = {
  retracedId: 'are_contracts_for_all_persons_who_perform_work_for_the_fac_both',
  name: 'Are contracts for all persons who perform work for the facility, both on the premises and offsite, in line with legal requirements?',
  description:
    'Consult applicable legal requirements before answering this question. \r\r\n\r\r\nEmployment contracts cannot contain provisions that are less favorable to workers than the law. In addition, applicable legal requirements should be consulted to determine whether provisions that relate specifically to employment contracts have been complied with (e.g., regarding written format, contents, language, etc.).\r\r\n\r\r\nAnswer Yes if contracts are in place as required, contracts are up to date and contract content is in line with legal requirements.\r\r\n\r\r\nAnswer No if the facility either does not have contracts in place (and they are LEGALLY required) OR contracts do not meet legal requirements.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ep-3--1',
      version: '1.5.0',
      provider: 'slcp',
    },
  ],
  sortingId: 5990,
  sectionId: '2.2.4',
  impactArea: 'Contracts and HR',
  impactAreaId: 'CONTRACTS_AND_TERMS_OF_EMPLOYMENT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
